import { Skeleton } from '@moneyforward/ap-frontend-components';
import classnames from 'classnames/bind';
import { FC, memo, PropsWithChildren, Suspense } from 'react';
import styles from './Select.module.scss';

const cx = classnames.bind(styles);

export const SuspenseSelect: FC<PropsWithChildren> = memo(({ children }) => {
  return (
    <Suspense
      fallback={
        <div className={cx(styles['skelton-container'])}>
          <Skeleton.Input active size='default' block />
        </div>
      }
    >
      {children}
    </Suspense>
  );
});
SuspenseSelect.displayName = 'SuspenseSelect';
